import styled from 'styled-components';
import { DoorOpen } from '@styled-icons/boxicons-solid/DoorOpen';
import { PlusCircle } from '@styled-icons/fa-solid/PlusCircle';
import { ToastContainer } from 'react-toastify';
import theme from 'theme/index';

export const StyledContainer = styled(ToastContainer)`
  .Toastify__toast {
    margin-top: 76px;
  }
`;

export const PlusCircleIcon = styled(PlusCircle)`
  color: #20907F;
  border-radius: .5em;
  width: 1em;
  margin-left: 5px;
  font-weight: bold;
`;

export const Button = styled.button`
  background-color: white;
  border: 1px solid #20907f;
  color: #20907f;
  width: 110px;
  max-width: 180px;
  border-radius: 25px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    background-color: #ccc;
    border: 1px solid #ccc;
    color: white;
    cursor: pointer;
  }
  margin-left: 10px;
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  width: 100%;
`;

export const SilhouetteIcon = styled.div`
    color: #20907F;
    position: relative;
    margin: auto;
    height: 75px;
    width: 45px;
    overflow: hidden;
    text-align: center;
`;

export const DoorOpenIcon = styled(DoorOpen)`
  margin-top: 12px;
`;

export const ActionSection = styled.div`
  width: 50%;
  text-align: center;
  font-family: Helvetica, "Open Sans", sans-serif;
  font-weight: bold;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: right;
`;

export const Container = styled.div`
  font-family: Helvetica, "Open Sans", sans-serif;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  span.instruction {
    font-weigth: bold;
  }
`;

export const AvailabilityOffset = styled.div`
  position: relative;
`;

export const HeaderSection = styled.div`
  width: 50%;
`;

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Helvetica, "Open Sans", sans-serif;
  font-size: 100%;
  color: #5a5b5e;
  min-height: 100vh;
  background-color: white;
`;

export const PageBody = styled.div`
  flex: 1 0 auto;
  position: relative;
`;

export const PageHeader = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  padding: 20px 20px 0px 20px;
`;

export const PageTitle = styled.span`
  font-size: 28px;
  font-weight: 300;
  margin-left: 10px;
`;

export const Spacer = styled.div`
  flex: 1 1 0;
`;

export const TabValue = styled.button<{ isSelected: boolean, featureFlag: boolean }>`
  background-color: transparent;
  color: ${props => !props.featureFlag ? theme.sherpaBlue : (props.isSelected ? theme.mint : theme.grey)};
  font-family: Helvetica, "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: bold;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  transition: color 0.1s ease;
  border-bottom: ${props => props.isSelected && props.featureFlag ? `2px solid ${theme.mint}` : 'none'};
  text-align: left;
`;

export const TabContainer = styled.div`
  display: flex;
  margin: 30px 20px;
  border-bottom: 1px solid ${theme.lightGrey};
`;
